import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule, UrlSegment } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subject, takeUntil } from 'rxjs';
import { Route } from 'src/app/models/enums/Route.enum';
import { RulesService } from 'src/app/services/api/rules.service';

interface Breadcrumb {
  label: string,
  url: string
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  imports: [RouterModule, CommonModule]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();
  private _breadcrumb: Breadcrumb[] = [];

  public showBreadcrumb: boolean = true;
  public get breadcrumb(): Breadcrumb[] {
    return this._breadcrumb;
  }

  constructor(
    private readonly rulesService: RulesService,
    private readonly t: TranslateService,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.setBreadcrumb();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this._destroying$)
    ).subscribe(() => {
      this.setBreadcrumb();
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  /**
   * Costruisco il breadcrumb ciclando sui segments del router e costruendo man mano i vari link
   */
  setBreadcrumb() {
    let router: any = this.router;
    this._breadcrumb = [];
    try {
      if (router.url.includes(Route.AddOn)) {
        this.showBreadcrumb = false;
        return;
      } else {
        this.showBreadcrumb = true;
      }
      const segments: UrlSegment[] = router.rawUrlTree.root.children.primary.segments
      let url = "";
      segments.forEach((segment) => {
        url += `/${segment.path}`;
        // let label = this.t.instant(segment.path);
        // if (label.includes("-")) {
        //   label = label.replaceAll("-", " ");

        let label = segment.path;
        //Se il segment è un ID allora seleziono la rule dall mappa e seleziono il suo "name"
        if (!isNaN(parseInt(label))) {
          let node = this.rulesService.rulesMap.get(parseInt(segment.path));
          label = node?.name ?? '...';
        } else {
          label = this.t.instant(label);
        }
        this._breadcrumb.push({ label, url });
      });
    } catch (e) {
      console.error(e);
      //Nascondo il breadcrumb se per un motivo o per un altro si verifica un errore nella sua costruzione
      this.showBreadcrumb = false;
    }
  }
}
